var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarToy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M34.712,282.034c-4.799,0-8.678-3.888-8.678-8.678V117.153c0-4.79,3.879-8.678,8.678-8.678 s8.678,3.888,8.678,8.678v156.203C43.39,278.146,39.511,282.034,34.712,282.034"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M34.712,125.831C15.568,125.831,0,110.262,0,91.119s15.568-34.712,34.712-34.712 s34.712,15.568,34.712,34.712S53.855,125.831,34.712,125.831"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M407.864,273.356H86.78v-86.511c0-14.527,11.776-26.303,26.303-26.303h150.103 c36.508,0,70.942,16.957,93.201,45.898L407.864,273.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35C3EE"
    },
    d: "M8.678,292.5v91.882c0,10.57,8.574,19.144,19.144,19.144h24.246 c0-28.759,23.309-52.068,52.068-52.068s52.068,23.309,52.068,52.068h208.271c0-28.759,23.309-52.068,52.068-52.068 c28.759,0,52.068,23.309,52.068,52.068h24.246c10.57,0,19.144-8.574,19.144-19.144V292.5c0-10.57-8.574-19.144-19.144-19.144 H27.822C17.252,273.357,8.678,281.931,8.678,292.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M156.203,403.525c0,28.759-23.309,52.068-52.068,52.068s-52.068-23.309-52.068-52.068 s23.309-52.068,52.068-52.068S156.203,374.767,156.203,403.525"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M468.61,403.525c0,28.759-23.309,52.068-52.068,52.068c-28.759,0-52.068-23.309-52.068-52.068 s23.309-52.068,52.068-52.068C445.301,351.458,468.61,374.767,468.61,403.525"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.729,325.424h-43.39c-4.799,0-8.678-3.888-8.678-8.678c0-4.79,3.879-8.678,8.678-8.678h43.39 c4.799,0,8.678,3.888,8.678,8.678C312.407,321.536,308.528,325.424,303.729,325.424"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D4D1"
    },
    d: "M112.814,403.525c0,4.79-3.888,8.678-8.678,8.678c-4.79,0-8.678-3.888-8.678-8.678 c0-4.79,3.888-8.678,8.678-8.678C108.926,394.847,112.814,398.735,112.814,403.525"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D4D1"
    },
    d: "M425.22,403.525c0,4.79-3.888,8.678-8.678,8.678c-4.79,0-8.678-3.888-8.678-8.678 c0-4.79,3.888-8.678,8.678-8.678C421.333,394.847,425.22,398.735,425.22,403.525"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M512,342.78h-26.034c-9.589,0-17.356-7.767-17.356-17.356c0-9.589,7.767-17.356,17.356-17.356H512 V342.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.339,334.102c-4.799,0-8.678-3.888-8.678-8.678v-8.678c0-4.79,3.879-8.678,8.678-8.678 s8.678,3.888,8.678,8.678v8.678C269.017,330.214,265.138,334.102,260.339,334.102"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.729,334.102c-4.799,0-8.678-3.888-8.678-8.678v-8.678c0-4.79,3.879-8.678,8.678-8.678 s8.678,3.888,8.678,8.678v8.678C312.407,330.214,308.528,334.102,303.729,334.102"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D4D1"
    },
    d: "M265.358,273.356h36.56l-15.646-47.304c-3.003-9.06-12.869-14.024-21.929-11.03 c-9.06,3.003-14.024,12.869-11.03,21.929L265.358,273.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D4D1"
    },
    d: "M144.09,273.356h36.907l-17.156-47.477c-3.237-8.982-13.243-13.676-22.216-10.431 c-8.982,3.246-13.668,13.243-10.431,22.224L144.09,273.356z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M43.39,325.424c4.799,0,8.678-3.888,8.678-8.678c0-4.79-3.879-8.678-8.678-8.678H8.678v17.356H43.39 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarToy);
export default __webpack_public_path__ + "static/media/CarToy.8f19a598fb3c92996b011c4d19c0bcfb.svg";
export { ForwardRef as ReactComponent };